import type { LastViewedEntityBookmarkBody } from '@softapps/core';

export interface SalesDocumentSearchResult {
  id: string;
  documentType: string;
  documentNumber: number | null;
  customerName: string | null;
  customerNumber: number | null;
  documentDate: number | null;
}

export const DOCUMENT_SEARCH_DOCUMENT_TYPES = [
  'SALES_ORDER',
  'OFFER',
  'BLANKET_ORDER',
  'DELIVERY_NOTE',
  'INVOICE',
  'WORK_ORDER',
  'COMMISSION_NOTE',
] as const;

/** Rebuilds the hit the renderer stored as `${documentType}_${id}` / number / customer
    name once the portal-service dropped `result` from the last-viewed body. Only the fields
    the search row needs for its actions come back; date and Vkforg stay unknown. */
export function restoreSalesDocumentHit(
  body: LastViewedEntityBookmarkBody
): SalesDocumentSearchResult | null {
  const documentType = DOCUMENT_SEARCH_DOCUMENT_TYPES.find((type) =>
    body.key?.startsWith(`${type}_`)
  );
  const id = documentType ? body.key.slice(documentType.length + 1).trim() : '';
  if (!documentType || !id) return null;
  const number =
    body.number?.trim() ||
    new URL(body.url ?? '', 'http://x').searchParams.get('documentNumber') ||
    '';
  return {
    id,
    documentType,
    documentNumber: /^\d+$/.test(number) ? Number(number) : null,
    customerName: body.description?.trim() || null,
    customerNumber: null,
    documentDate: null,
  };
}
